import { RestService } from '../../shared/providers/rest.service';
import {
  Component,
  OnInit,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
/*import { CompleterService, CompleterData, Ng2CompleterModule } from 'ng2-completer';*/
import { ToastService } from '../../shared/providers/toast.service';
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { IExchange1031PropertySuggestOutputModel } from '../../shared/models/Exchange1031PropertySuggestOutputModel';
import { ValidationService } from '../../shared/providers/validation.service';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { PropertyListingBase } from '../../property-listing/property-listing-base';
import { HttpClient } from '@angular/common/http';
import { IPropertySearchCriteria } from '../../shared/models/propertysearchcriteria';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { AddTo1031Exchange } from '../../shared/models/AddTo1031ExchangeModel';
import { CommonService } from '../../shared/providers/common.service';
import { PropertyFor, LookUp } from '../../shared/enum/enum';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { ActivatedRoute, Params } from '@angular/router';
import { MatSelect } from '@angular/material/select';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  Observable,
  of,
  Subject,
  switchMap,
  tap,
} from 'rxjs';
@Component({
  selector: 'app-property-suggest',
  templateUrl: './exchange-1031-suggest.component.html',
  styles: [
    '.search-div { display: flex; align-items: center }'
  ]
})
export class Exchange1031SuggestComponent
  extends PropertyListingBase
  implements OnInit
{
  currentPoint: number;
  dataService: []; /*CompleterData;*/
  filterStateId = null;
  suggestPropertyIds = [];
  _takeCount = 20;
  search = '';
  dtOptions = {};
  addTo1031Exchange = {} as AddTo1031Exchange;
  searchCriteria = {} as IPropertySearchCriteria;
  IsValid: boolean = false;
  inputAssetTypes = [];
  inputRatings = [];
  inputTenants = [];
  inputTerms = [];
  existingProperty: any = null;
  isSuccess: boolean = false;
  IsLoading = false;
  @ViewChild('select') select: MatSelect;
  //defaultTypeText = {
  //  checked: 'item selected',
  //  checkedPlural: 'items selected',
  //  defaultTitle: 'Property Type'
  //};
  //defaultTypeSettings = {
  //  dynamicTitleMaxItems: 1
  //}
  defaultTypeSettings = {
    singleSelection: false,
    text: 'Property Type',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: 'myclass custom-class',
    enableFilterSelectAll: false,
  };
  //defaultTenantText: IMultiSelectTexts = {
  //  checked: 'item selected',
  //  checkedPlural: 'items selected',
  //  defaultTitle: 'Tenant Trade',
  //  searchEmptyResult: 'No results found...',
  //};
  defaultTenantSettings = {
    singleSelection: false,
    text: 'Tenant Trade',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: 'myclass custom-class',
    enableFilterSelectAll: false,
  };
  //defaultCreditText: IMultiSelectTexts = {
  //  checked: 'item selected',
  //  checkedPlural: 'items selected',
  //  defaultTitle: 'Rating'
  //};
  defaultCreditSettings = {
    singleSelection: false,
    text: 'Rating',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: 'myclass custom-class',
    enableFilterSelectAll: false,
  };
  //defaultTermText: IMultiSelectTexts = {
  //  checked: 'item selected',
  //  checkedPlural: 'items selected',
  //  defaultTitle: 'Term'
  //};
  defaultTermSettings = {
    singleSelection: false,
    text: 'Term',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: 'myclass custom-class',
    enableFilterSelectAll: false,
  };
  /*propertyDataService: CompleterData;*/
  @ViewChild('dropdownTenants') dropdownTenants: any;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  constructor(
    protected http: HttpClient,
    protected _propertyListingService: PropertyListingService,
    private _propertyManagementService: PropertyManagementService,
    private Authentication: AuthenticationService,
    public _validationService: ValidationService,
    private modalService: BsModalService,
    /*private completerService: CompleterService, */ public _commonService: CommonService,
    private Toast: ToastService,
    private _restService: RestService,
    private Loader: LoaderService,
    protected activatedRoute: ActivatedRoute
  ) {
    super(
      _propertyListingService,
      http,
      Authentication,
      Loader,
      activatedRoute
    );
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      //const propertyDataProvider = completerService.remote(null, 'PropertyName', 'PropertyName');
      //propertyDataProvider.urlFormater(x => {
      //  return encodeURI(this.BASE_URL + '/property/GetAddressByAutocomplete?searchText=' + encodeURIComponent(x) + '&userId=' + (this.user ? this.user.Id : 0));
      //});
      //propertyDataProvider.descriptionField('Type');
      //this.propertyDataService = propertyDataProvider;
    });
  }

  @Input() selectedExchange: number = 0;
  @Input() suggested = [];
  @Output() close = new EventEmitter();
  LoggedInUser: any;
  ngOnInit() {
    this.LoggedInUser = this.Authentication.user;
    this.clearPropertyModel();
    this.defaultSearchCriteriaValues();
    this.searchCriteria.PriceFrom = this._validationService.commaFormat(
      this.searchCriteria.PriceFrom
    );
    this.searchCriteria.PriceTo = this._validationService.commaFormat(
      this.searchCriteria.PriceTo
    );

    this.searchCriteria.Address = this.searchCriteria.Address != null && this.searchCriteria.Address != '' ? null : this.searchCriteria.Address;

    // Loads the property type
    this._commonService.getTypeList().subscribe((response) => {
      this.inputAssetTypes = response.map((o) => {
        return { id: o.Id, name: o.Type };
      });
    });

    this._commonService
      .getLookupsByTypeId(LookUp.Rating)
      .subscribe((response) => {
        if (response != null && response.length > 0) {
          response = response.filter((x) => x.IsActive == true);
          this.inputRatings = response.map((o) => {
            return { id: o.Id, name: o.Description };
          });
        }
      });

    //this._propertyListingService.getTenants().subscribe(response => {
    //    if (response != null && response.length > 0) {
    //        this.inputTenants = response.map(o => { return { id: o.Id, name: o.TradeName }; });
    //    }
    //});

    this._propertyListingService.getTerms().subscribe((response) => {
      if (response != null && response.length > 0) {
        this.inputTerms = response.map((o) => {
          return { id: o.Id, name: o.Term };
        });
      }
    });

    this.loadItems();
  }
  propertySuggestList: IExchange1031PropertySuggestOutputModel[];
  modalRef: BsModalRef;

  dataService$: Observable<any[]>;
  dataServiceInput$ = new Subject<string>();
  loading = false;

  private loadItems() {
    this.dataService$ = this.dataServiceInput$.pipe(
      distinctUntilChanged(),
      debounceTime(400),
      tap(() => (this.loading = true)),
      switchMap((term) =>
        this.getItems(term).pipe(
          catchError(() => of([])), // empty list on error
          tap(() => (this.loading = false))
        )
      )
    );
  }

  getItems(term: any = null): Observable<any[]> {
    return this._propertyManagementService.GetAddressByAutocomplete(term, (this.LoggedInUser ? this.LoggedInUser.Id : 0), 0);

  }

  openModal(template: TemplateRef<any>, classes) {
    this.clearPropertyModel();
    this.modalRef = this.modalService.show(template, { class: classes });
  }
  clearPropertyModel() {
    this.invalidSelection = false;
    this.propertySelected = '';
    this.loadProperties();
  }

  loadProperties() {
    this.user = this.authService.user;
    this.searchCriteria.LoggedInUserId = this.user != null ? this.user.Id : 0;
    if (
      this.searchCriteria.StateId != null &&
      this.searchCriteria.StateId != undefined &&
      typeof this.searchCriteria.StateId === 'number'
    ) {
      this.filterStateId = this.searchCriteria.StateId;
    }
    //} else if ((this.searchCriteria.StateId != null && this.searchCriteria.StateId != undefined && this.searchCriteria.StateId) && typeof this.searchCriteria.StateId === 'object') {
    //  this.filterStateId = this.searchCriteria.StateId?.[0];
    //}
    this.searchCriteria.PropertyFor = 602;
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      pageLength: 50,
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        dataTablesParameters.Extra_param = this.searchCriteria;
        this.IsLoading = true;
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/property/propertieslistview',
            dataTablesParameters,
            {}
          )
          .subscribe((resp) => {
            this.propertySuggestList = resp ? (resp.data ? resp.data : []) : [];
            this.searchCriteria.SortValue = '';
            //this.propertySuggestList = this.propertySuggestList.filter(function (item) {
            //    return !test.includes(item) ? true : test.splice(test.indexOf(item), 1) && false;
            //});
            if (resp.data.length === 0) {
              $('.dataTables_paginate.paging_full_numbers').hide();
            }
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: [],
              });
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: [],
              });
            }
            $('.paginate_button.first,.paginate_button.last').hide();
            this.IsLoading = false;
          });
      },
      columnDefs: [
        { orderable: false, targets: 0 },
        { orderable: false, targets: 1 },
      ],
      columns: [
        { data: 'Guid' },
        { data: 'OMFilePath' },
        { data: 'PropertyName' },
        { data: 'State' },
        { data: 'AssetType' },
        { data: 'PropertyStatus' },
        { data: 'Price' },
        { data: 'RentNOI' },
        { data: 'CreditRating' },
        { data: 'CapRate' },
        { data: 'RemainingTerm' },
        { data: 'LeaseStructure' },
        { data: 'BuildingSize' },
      ],
    };
  }

  propertySelected;
  invalidSelection = false;
  onPropertySelect($event) {
    if ($event.originalObject !== null) {
      //this.showPrincipalDtls = true;
      this.propertySelected = $event.originalObject;
    }
  }
  validationMsg = '';

  onAdd($event) {
    if (this.suggestPropertyIds.length == 0) {
      this.invalidSelection = true;
      this.Toast.addToast({
        title: 'Error Occurred',
        msg: 'Please select at least one property to suggest',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    } else {
      this.invalidSelection = false;
      this.Loader.display(true);
      this.addTo1031Exchange.UserId = this.LoggedInUser.Id;
      this.addTo1031Exchange.Exchange1031Id = this.selectedExchange;
      this.addTo1031Exchange.Exchange1031GroupId = 2200;
      this.suggestPropertyIds.forEach((item) => {
        this.addTo1031Exchange.PropertyId = item;
        this._propertyManagementService
          .addTo1031Exchange(this.addTo1031Exchange)
          .subscribe((response) => {
            if (response) {
              this.isSuccess = true;
              this.onClose($event);
            } else {
              this.Toast.addToast({
                title: 'Error Occurred',
                msg: 'Failed to add seleteed property',
                timeout: 5000,
                theme: 'bootstrap',
                position: 'bottom-right',
                type: 'error',
              });
            }
          });
      });
      setTimeout(() => {
        if (this.isSuccess == true) {
          this.Toast.addToast({
            title: 'Message',
            msg: 'You successfully added property / properties to 1031 exchange suggest list!',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success',
          });
        }
        this.Loader.display(false);
      }, 2000);
    }
  }

  selectAllCheckbox = false;
  onChecked(data) {
    if (data.IsChecked) {
      this.existingProperty = this.suggested.filter(
        (x) => x.PropertyId == data.Id
      )[0];
      if (this.existingProperty != null && this.existingProperty != undefined) {
        this.propertySuggestList.find((x) => x.Id == data.Id).IsChecked = false;
        this.propertySuggestList.find(
          (x) => x.Id == data.Id
        ).DisabledSelection = true;
        this.Toast.addToast({
          title: 'Error Occurred',
          msg:
            this.existingProperty.PropertyName +
            ' is already exists in suggested list',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error',
        });
      } else {
        this.suggestPropertyIds.push(data.Id);
      }
    } else {
      const index: number = this.suggestPropertyIds.indexOf(data.Id);
      if (index !== -1) {
        this.suggestPropertyIds.splice(index, 1);
      }
    }
    let checkedCount = 0;
    this.propertySuggestList.forEach((item) => {
      if (item.IsChecked) {
        checkedCount++;
      }
    });
    if (checkedCount === this.propertySuggestList.length) {
      this.selectAllCheckbox = true;
    } else {
      this.selectAllCheckbox = false;
    }
  }

  onClose($event) {
    this.close.emit(true);
  }

  /**
   * Overriden the base class method
   * @param searchParameters
   */
  propertySearchCriteria(searchParameters: IPropertySearchCriteria) {
    this.currentPoint = 0;
    this.searchCriteria = searchParameters;
    const searchCriteria: IPropertySearchCriteria = {
      Address: this.searchCriteria.Address,
      AssetTypes: this.searchCriteria.AssetTypes,
      Ratings: this.searchCriteria.Ratings,
      PriceFrom: this.searchCriteria.PriceFrom,
      PriceTo: this.searchCriteria.PriceTo,
      SkipCount: this.currentPoint,
      SortValue: this.searchCriteria.SortValue,
      TakeCount: this._takeCount,
      Tenants: this.searchCriteria.Tenants,
      Terms: this.searchCriteria.Terms,
      IsMapView: this.searchCriteria.IsMapView,
      Guid: this.searchCriteria.Guid,
      NOIFrom: this.searchCriteria.NOIFrom,
      NOITo: this.searchCriteria.NOITo,
      BuildingSizeFrom: this.searchCriteria.BuildingSizeFrom,
      BuildingSizeTo: this.searchCriteria.BuildingSizeTo,
      YearBuiltFrom: this.searchCriteria.YearBuiltFrom,
      YearBuiltTo: this.searchCriteria.YearBuiltTo,
      StateId: this.filterStateId,
      LeaseStructures: this.searchCriteria.LeaseStructures,
      CapRateFrom: this.searchCriteria.CapRateFrom,
      CapRateTo: this.searchCriteria.CapRateTo,
      PropertyStatus: this.searchCriteria.PropertyStatus,
      SubCategories: this.searchCriteria.SubCategories,
      IsRentAmount: this.searchCriteria.IsRentAmount,
      RentFrom: this.searchCriteria.RentFrom,
      RentTo: this.searchCriteria.RentTo,
      OwnershipTypes: this.searchCriteria.OwnershipTypes,
      IsExcludeSoldListing: this.searchCriteria.IsExcludeSoldListing,
      IsOnlySoldListing: this.searchCriteria.IsOnlySoldListing,
      IsExcludeContractListing: this.searchCriteria.IsExcludeContractListing,
      IsOnlyFeaturedListing: this.searchCriteria.IsOnlyFeaturedListing,
      LoggedInUserId: this.searchCriteria.LoggedInUserId,
      IsFavorite: this.searchCriteria.IsFavorite,
      PropertyFor: this.searchCriteria.PropertyFor,
      IsComp: this.searchCriteria.IsComp,
      IsArchive: this.searchCriteria.IsArchive,
      IsDisliked: this.searchCriteria.IsDisliked,
      IsSearchButtonClicked: this.searchCriteria.IsSearchButtonClicked,
      MinTerm: this.searchCriteria.MinTerm,
      MaxTerm: this.searchCriteria.MaxTerm,
      Brokerages: this.searchCriteria.Brokerages,
      States: this.searchCriteria.States,
      AddressTypeId: this.searchCriteria.AddressTypeId,
      AddressType: this.searchCriteria.AddressType,
      AddressTypeName: this.searchCriteria.AddressTypeName,
      CharacteristicsId: this.searchCriteria.CharacteristicsId,
      PropertyId: this.searchCriteria.PropertyId,
    };
    this.searchCriteria = searchCriteria;
    this.dtElement.dtInstance.then((x) => x.draw());
  }

  onResetClick() {
    var input = $('.search-field-input');
    input.each(function (item) {
      $(input[item]).val('');
    });
    this.dataServiceInput$.next('');
    // if (this.dropdownTenants != undefined && this.dropdownTenants != null) {
    //   this.dropdownTenants.clearSearch();
    // }
    this.defaultSearchCriteriaValues();
    this.onPropertySearch();
  }
  onInputKeyPress(event) {
    if (event.key === 'Enter') {
      this.onPropertySearch();
    }
  }

  validateFilters() {
    if (this.IsValid == true) {
      this.searchInformationValidation();
    }
  }

  onPropertySearch() {
    var address = this.searchCriteria.Address;
    this.searchInformationValidation();
    if (this.IsValid == true) {
      this.propertySearchCriteria(this.searchCriteria);
    } else {
      return false;
    }
  }

  searchInformationValidation() {
    this.IsValid = true;
    if (
      this._validationService.IsNull(this.searchCriteria.PriceFrom) != '' &&
      this._validationService.IsNull(this.searchCriteria.PriceTo) != '' &&
      Number(this.searchCriteria.PriceFrom) >
        Number(this.searchCriteria.PriceTo)
    ) {
      this.IsValid = false;
      this.Toast.addToast({
        title: 'Error Occurred',
        msg: 'Price To should be greater than Price From',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    }
  }

  defaultSearchCriteriaValues() {
    this.searchCriteria.PropertyId = 0;
    this.searchCriteria.SkipCount = 0;
    this.searchCriteria.TakeCount = 20;
    this.searchCriteria.Address = '';
    this.searchCriteria.AssetTypes = [];
    this.searchCriteria.PriceFrom = null;
    this.searchCriteria.PriceTo = null;
    this.searchCriteria.Ratings = [];
    this.searchCriteria.Terms = [];
    this.searchCriteria.SortValue = 'PLH';
    this.searchCriteria.IsSearchButtonClicked = false;
  }

  onPropertyAutocompleteSelect($event) {
    if ($event != null ) {
      this.searchCriteria.Address = $event.PropertyName;
      this.searchCriteria.AddressTypeId = $event.Id;
      this.searchCriteria.AddressType = $event.AddressTypeID;
      this.searchCriteria.AddressTypeName = $event.Type;
    } else {
      this.searchCriteria.AddressTypeId = 0;
      this.searchCriteria.AddressType = 0;
      this.searchCriteria.AddressTypeName = null;
    }
    this.onPropertySearch();
  }

  onKeydown(event) {
    if (event.key === 'Enter') {
      this.onPropertySearch();
    } else if (event.key === 'Backspace') {
      this.onPropertySelect(event);
    }
  }

  searchTerm: string = '';

  compareById(item1: any, item2: any): boolean {
    return item1?.Id === item2?.Id;
  }


  displayFn(item: any): string {
    return item ? (item.PropertyName != null && item.PropertyName != undefined ) ? item.PropertyName :item :'';
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }
}
